import React, { useState } from 'react';
import CustomNavbar from '../../components/navbarUser';
import Sidebar from '../../components/sibebarUser';
import MainContent from '../../components/mainContent';
import '../../style/dashboard.css'; // Estilos gerais
import EditUserIndex from '../Painel/editUser'



const EditUser = () => {

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="dashboard-container">
      {/* Sidebar */}
      <Sidebar isOpen={isSidebarOpen} />

      {/* Área de conteúdo */}
      <div className={`main-area ${isSidebarOpen ? 'sidebar-open' : ''}`}>
        {/* Navbar */}
        <CustomNavbar toggleSidebar={toggleSidebar} />

        {/* Conteúdo principal */}
        <MainContent>
          {/* Aqui você pode adicionar o componente DynamicForm */}
          <EditUserIndex />
        </MainContent>
      </div>
    </div>
  );
};

export default EditUser;
